import {Button, message, Modal, Progress} from "antd";
import React, {useState} from "react";
import {API_URL} from "../../../constants";
import {authHeader, download, safeFileName, UpdateJobProgress} from "../../../Utilities";
import axios from "axios";
import Hierarchy from "../../ImageViewerHandlers/Hierarchy/Hierarchy";
import HierarchyNode from "../../ImageViewerHandlers/Hierarchy/HierarchyNode";
import moment from "moment";

export function PartialHierarchyModal({hierarchy, node, setVisible, visible}: {
    hierarchy: Hierarchy,
    node: HierarchyNode,
    setVisible: React.Dispatch<React.SetStateAction<boolean>>
    visible: boolean,
}) {
    return (
        <Modal
            title="Download node hierarchy"
            visible={visible}
            onCancel={() => setVisible(false)}
            destroyOnClose={true}
            footer={null}
        >
            <DownloadPartialHierarchy hierarchyId={hierarchy.id} nodeId={node.id!} nodeName={node.text}/>
        </Modal>
    );
}

type DownloadPartialHierarchyProps = {
    hierarchyId: string,
    nodeId: string,
    nodeName: string,
}

function DownloadPartialHierarchy({hierarchyId, nodeId, nodeName}: DownloadPartialHierarchyProps) {
    const [progress, setProgress] = useState({status: "", percent: 0});
    const [spinning, setSpinning] = useState(false);

    const start = () => {
        setSpinning(true);
        axios.post(
            `${API_URL}/hierarchies/${hierarchyId}/export_for_bulk_update?node_id=${nodeId}`
        ).then(resp => {
            const taskId = resp.data;
            const updateProgress = new UpdateJobProgress().withDefaultUpdateProgress(setProgress);
            return updateProgress.do(
                `${API_URL}/hierarchies/${hierarchyId}/export_for_bulk_update/${taskId}/progress`
            ).then(_ => {
                return axios.get(
                    `${API_URL}/hierarchies/${hierarchyId}/export_for_bulk_update/${taskId}/download`,
                    {
                        headers: authHeader(),
                        responseType: "blob"
                    }
                ).then(response => {
                    const blob = new window.Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
                    download(blob, `partial_hierarchy_${safeFileName(nodeName)}_${moment().format("YYYY-MM-DD_HH-mm-ss")}.xlsx`);
                    message.success("Partial hierarchy exported successfully");
                });
            });
        }).catch(error => {
            console.error(error);
            message.error("Failed to export");
        }).finally(() => {
            setSpinning(false);
        });
    };

    return (
        <>
            <Button type={"primary"} onClick={() => start()}>
                Download
            </Button>
            {spinning && (
                <div>
                    {progress.status}
                    <Progress percent={progress.percent}/>
                </div>
            )}
        </>
    );
}
